export default __webpack_public_path__ + "static/media/dmtechtree1.3fece86c.png";